export default [
  {
    path: "stock/cloth-loan-list",
    name: "ClothLoanList",
    component: () => import("@/pages/ClothLoan/List.vue"),
    meta: {
      title: "版衣借调",
      requireAuth: true,
    },
  },
  {
    path: "stock/cloth-loan-create",
    name: "ClothLoanCreate",
    component: () => import("@/pages/ClothLoan/Create.vue"),
    meta: {
      title: "版衣借调单",
      requireAuth: true,
    },
  },
];



// WEBPACK FOOTER //
// ./src/router/routes/stock.js